import React from 'react';
import { IconButton, TableCell } from '../../../UIKit';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import { CellProps } from './CellProps';
import { PresenceType } from '../../../Models/DTO/Booking.models';

export interface PresenceStatusCellProps extends CellProps {
  presence: PresenceType;
  updatePresence: (presenceType: PresenceType) => void;
}

const PresenceStatusCell = ({ presence, updatePresence, className }: PresenceStatusCellProps) => (
  <TableCell className={className}>
    {presence === PresenceType.NONE && (
      <IconButton color="primary" onClick={() => updatePresence(PresenceType.PRESENT)} size="large">
        <AddCircleIcon />
      </IconButton>
    )}
    {presence === PresenceType.PRESENT && (
      <IconButton color="primary" onClick={() => updatePresence(PresenceType.ABSENT)} size="large">
        <RadioButtonCheckedIcon />
      </IconButton>
    )}
    {presence === PresenceType.ABSENT && (
      <IconButton color="primary" onClick={() => updatePresence(PresenceType.NONE)} size="large">
        <RemoveCircleIcon />
      </IconButton>
    )}
  </TableCell>
);

export default PresenceStatusCell;
